import React from 'react';
import './../styles/compsStyles/headerphoto.css';
import { FiSettings} from 'react-icons/fi';
import { FaMoneyBillWave} from 'react-icons/fa';
import { BsThreeDots } from 'react-icons/bs';
import { IoIosArrowBack } from 'react-icons/io';
import {useNavigate} from 'react-router-dom';

const HeaderPhoto = props =>{
  const navigate = useNavigate();
  const title = props.title || props.name;
  const showStudio = Boolean(props.onTitleClick);
  const goBack = () => {
    if (window.history.length > 1) navigate(-1);
    else navigate('/profile');
  };
  return(
<div className={props.watch?"headerphotoWatch":'headerphoto'}>
<p>{props.showBack ? (
  <button type="button" className="headerphotoBack" onClick={goBack} aria-label="Go back"><IoIosArrowBack /></button>
) : (
  <>
    <span onClick={()=>navigate('../settings')}><FiSettings /></span>
    <span onClick={()=>navigate('../earnings')}><FaMoneyBillWave /></span>
  </>
)}</p> <div>{showStudio ? (
  <button
    type="button"
    className="profileMoreBtn"
    onClick={() => navigate('/studio')}
    aria-label="Playlists and analytics"
  >
    <BsThreeDots />
  </button>
) : props.hidePhoto ? (
  <span className="headerphotoMark" aria-hidden="true"><FiSettings /></span>
) : (
  <img src={`/api/uploads/${props.img}`} alt="" className="headerphotoHome" onClick={()=>navigate('/profile')} />
)}<figure>{props.onTitleClick ? (
  <button
    type="button"
    className={`profileEditBtn${props.titleActive ? ' isActive' : ''}`}
    onClick={props.onTitleClick}
  >
    {title}
  </button>
) : (
  <h1>{title}</h1>
)}</figure></div>
</div>
  )
}

export default HeaderPhoto;
